import { Injectable } from '@angular/core';
import { AbstractControlOptions, UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { OtherInfo } from '@app/forms/subscription/definition/interface/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: OtherInfo) {
    let options: AbstractControlOptions = {};
    const formBuilderGroup = this.formBuilder.group(
      {
        ownerId: [entity?.ownerId],
        userFirstName: [entity?.userFirstName],
        userLastName: [entity?.userLastName],
        userUsCitizen: [
          entity && entity.hasOwnProperty('userUsCitizen')
            ? entity.userUsCitizen
            : false,
        ],
        userUsResident: [
          entity && entity.hasOwnProperty('userUsResident')
            ? entity.userUsResident
            : false,
        ],
      },
      options,
    );

    return formBuilderGroup;
  }
  generate(entity: OtherInfo[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
